import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import { colors, fonts, settings, zindex, animate } from '../styles/theme';
import { navBarColor, navHeight, navAccentColor, navWrapperTheme } from './theme-nav';

const readyStyle = css`
  * {
    filter: none;
  }
  animation: 1s delay-overflow;
  @keyframes delay-overflow {
    from {
      overflow: hidden;
    }
  }
`;

const loadingStyle = css`
  overflow: hidden;
  > * {
    filter: blur(4px);
    pointer-events: none;
  }
  div > div {
    background: none;
  }
`;

// the box-shadow belongs on the layout wrapper
export const NavWrapper = styled('nav')`
  background-color: ${navBarColor};
  height: ${navHeight};
  font-family: ${fonts.sans.family};
  position: relative;
  border-bottom: 1px solid ${navAccentColor};
  > * {
    transition: filter ${animate.transition} linear;
  }
  ${navWrapperTheme};
  ${(props) => (props.ready ? readyStyle : loadingStyle)}
`;

const alignments = {
  left: 'space-between',
  right: 'flex-end',
};

export const NavInnerWrapper = styled('div')`
  max-width: ${settings.page.maxWidth};
  display: flex;
  justify-content: ${(props) => alignments[props.align]};
  margin: 0 auto;
  padding: 0 10px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  @media screen and (max-width: 1000px) {
    padding: 5px 10px 20px;
    transition: all ${animate.transition} linear;
    position: fixed;
    right: 0px;
    top: 0;
    bottom: 0;
    width: 220px;
    box-shadow: 0 -1px 2px 0 ${colors.grey.secondaryDark};
    background: ${colors.white};
    overflow-y: auto;
    flex-direction: column;
    justify-content: flex-start;
    z-index: ${zindex.component.aboveBase};
    > * {
      border-bottom: 1px dotted ${colors.grey.secondaryDark};
      margin-bottom: 5px;
      padding-bottom: 5px;
    }
  }
`;
